export enum BillingFilterType {    
    Completed = 5,
    IncludePending = 6
}